import { SelectBox } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import isEmpty from 'lodash/isEmpty';
import { useController, useFormContext } from 'react-hook-form';

export type CabinClassSelectNewProps = {
  cabinClasses: {
    label: string;
    value: string;
  }[];
  className: string;
  'data-testid'?: string;
  description?: string;
  fieldName: string;
  label: string;
  placeholder: string;
  shouldMarkInputAsRequired: boolean;
};

const CabinClassSelectNew = ({
  cabinClasses,
  className,
  'data-testid': dataTestId,
  description,
  fieldName,
  label,
  placeholder,
  shouldMarkInputAsRequired,
}: CabinClassSelectNewProps) => {
  const { nonDebugT } = useTranslation();
  const { control } = useFormContext();
  const {
    field: { onChange, onBlur, name, value },
    fieldState: { error },
  } = useController({ control, name: fieldName, rules: { required: true } });
  const errorId = !isEmpty(error) ? `${name}-error` : undefined;
  const descriptionId = description ? `${name}-description` : undefined;
  const resolvedLabel = shouldMarkInputAsRequired
    ? nonDebugT('Input.Field.Required', label)
    : label;

  return (
    <SelectBox
      className={className}
      data-testid={dataTestId}
      descriptionId={descriptionId}
      errorId={errorId}
      hasError={!isEmpty(error)}
      isMultiple={false}
      label={resolvedLabel}
      name={name}
      onBlur={onBlur}
      onChange={(selectedOption) => {
        onChange(selectedOption.value);
      }}
      options={cabinClasses}
      placeholder={placeholder}
      value={value}
    />
  );
};

export default CabinClassSelectNew;
